import React from 'react';
import actions from '../actions/UsTodniKamkarAction';

var trstyle = { 'font-size': '17px' }
export default class BlakListWorkarReason extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            WorkarId: props.location.WorkarId,
            note: ''
        };
    }

    BlackListKamgar(e, note, WorkarId) {
        e.preventDefault();
        actions.BlackListKamgar({ note, WorkarId })
        this.props.history.push('/BlackListShow')
    }

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    render() {
        return (
            <div className="pages">
                <div data-page="form" className="page no-toolbar no-navbar">
                    <div className="page-content">
                        <div className="navbarpages navbarpagesbg">
                            <div className="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <div>
                                <h3 style={{ 'color': '#0000FF' }}><b style={{ 'padding-left': '40px' }}>ब्लाकलिस्ट करण्याचे कारण </b></h3>
                                <label style={trstyle}>शेरा :</label>
                                <input className="form-control" type="text" id="note" name="note" value={this.state.note}
                                    onChange={(e) => this.handleInputChange(e)} placeholder="ब्लाकलिस्ट करण्याचे कारण.." /><br />
                                <button type="button" className="btn btn-danger pull-right" onClick={(e) => { this.BlackListKamgar(e, this.state.note, this.props.location.WorkarId) }}>ब्लॉक</button>
                            </div >
                        </div >
                    </div >
                </div >
            </div >
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/BlakListKamgarReason.jsx